import axios from "axios"; //axios请求
import store from '@/store' //引入store管理
import {
	Message,
	MessageBox
} from 'element-ui' //引入element-ui的库文件
import {
	baseUrl,
	def
} from '@/config/env'; //公共域名
import qs from 'qs'; //引用qs

export function getToken() { //获得token
	return store.state.token
}

const service = axios.create({
	baseURL: baseUrl, // api的base_url
	timeout: 10000000000, // 请求超时时间
	method: def.reqMethod,
	headers: {
		'Content-Type': def.reqType == 'form' ? 'application/x-www-form-urlencoded' :
			'application/json;charset=utf-8'
	} //传参类型
});

service.interceptors.request.use(config => {
	// 在请求发送之前做些什么
	if (getToken()) {
		config.headers[def.tokenName] = getToken() // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
	}
	if (config.method == "post") { //qs使用
		// config.data = qs.stringify(config.data);
		config.data = JSON.stringify(config.data) || {};
		// console.log(config)
	}
	return config
}, error => {
	// 请求错误怎么办
	console.log(error) // for debug
	Promise.reject(error)
})


// respone拦截器
service.interceptors.response.use(

	response => {
		const res = response.data

		/**
		 * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
		 * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
		 */
		if (res.result == 0) { //0正常
			return res
		} else if (res.result == 1002) { //1002警告

			Message({
				message: res.msg,
				type: "warning"
			})
			return res

		} else {

			if (res.result === 1001) { //1001登录过期
				// to re-login
				MessageBox.confirm('登录失效，请重新登录', '确定前往登录吗？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					//登录失效执行什么
					store.commit("delToken") //删除token
				})

			} else { //其他报错

				Message({
					message: res.msg,
					type: 'error'
				});

			}

			return Promise.reject(new Error(res.message || 'Error'))
		}

	},
	error => { //请求错误
		console.log('err' + error) // for debug
		return Promise.reject(error)

	})


export default service;


// WEBPACK FOOTER //
// ./src/utils/request.js